// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".da9207{margin-top:calc(var(--spacer) + 1em);display:grid;border-left:1px solid var(--subtle);padding-left:var(--spacer);gap:var(--medium-spacer);margin-left:.5em}._1120eb:last-child{box-shadow:-3em 0 0 var(--background)}._1120eb:first-child:last-child{margin-left:calc(-1*var(--spacer) - .5em);background:var(--background)}._1120eb:first-child:last-child .caaa02{margin-left:0}._1120eb:first-child:last-child .caaa02:before{content:none}.caaa02{margin:-1em 0 .5em calc(-1*var(--spacer) - 6px);display:flex;color:var(--secondary);align-items:center;font-size:.875em;font-weight:500}.caaa02:before{content:\"\";width:11px;height:11px;background:var(--background);border-radius:100%;margin-right:calc(var(--spacer) - 6px);border:2px solid currentColor}", ""]);
// Exports
exports.locals = {
	"timeline": "da9207",
	"item": "_1120eb",
	"date": "caaa02"
};
module.exports = exports;
